export default "/_next/static/data/cdp_week_lottie_icon.json-1a095c713672570fa94e15ad6c5206c0.json";